import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, InternalSourcingFunnels } from "@/types";

export function useGetInternalSourcingFunnel() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["internal-sourcing-funnel", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/sourced-candidacies/funnel-counts`;
      const res = await guacHttpClient.get<
        InternalSourcingFunnels,
        HttpResponse<InternalSourcingFunnels>
      >(path);
      return res.data;
    },
  });
}
